import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { environment } from './environments/environment';

export function register() {
  const sdk = new HoneycombWebSDK({
    debug: !environment.production,
    endpoint: environment.services.honeycomb.endpoint,
    serviceName: 'stormcloud-pwa',
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: [environment.apiUrl],
        },
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: [environment.apiUrl],
        },
      }),
    ], // Adds automatic instrumentation
  });

  sdk.start();
}
